export function setBenefitsGroup(state, BenefitsGroup) {
  state.BenefitsGroup = BenefitsGroup;
}

export function setBenefitGroup(state, benefitGroup) {
  state.selectedBenefitGroup = benefitGroup;
}

export function BenefitsGroupError(state, payload) {
  state.error = true
  state.errorMessage = payload
  state.BenefitsGroup = []
}